import { helpers } from '@vuelidate/validators'
import type { TInstance } from '@/components/Inputs/Composables/validators/validators.types'

export function useMultiSelect(field: string, t: TInstance) {
  return ({
    [`${field}`]: {
      required: helpers.withMessage(
        () => t('formValidatorMessages.select.required'),
        (value: string[]) => Array.isArray(value) && value.length > 0,
      ),
    },
  })
}
